import { gsap } from "gsap";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import UtilityCard from "../components/UtilityCard";
import useWindowDimensions from "../hooks/useWindowDimensions";

const Utilities = () => {
  const { width } = useWindowDimensions();
  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#utilities-h", {
        stagger: 0.1,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from(".utility-card", {
        stagger: 0.1,
        opacity: 0,
        scale: 0.8,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id="utilities"
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-center container"
    >
      <h1 id="utilities-h" className="primary-h">
        Utilities
      </h1>
      <br />
      <div class="container" id="utilities-div">
        <div class="row">
          <UtilityCard
            id={1}
            title={"Be part of the world’s Ecoest NFT community"}
            desc={
              "When you join the Gutter Bats Planet - by purchasing an NFT or just joining our Discord - you’re instantly part of our community. A global community that empowers and supports each other on this exciting journey into Web 3.0. We’re focused on building authentic connections as we delve into the metaverse together."
            }
          />
          <div class="col-md-4">
            <div class={`utility-card utility-card-2`}>
              <h3>Access monthly ecolocation Rewards</h3>
              <p>
                As a Gutter Bats Planet NFT holder, you automatically gain
                access to our exclusive ecolocationRewards program which rewards
                you for participating in the community. Our program will
                continuously evolve as we look at new ways to reward our members
                with additional benefits.
                <br />
                <br />
                <Link
                  to="/rewards"
                  style={{ color: "var(--light)", cursor: "pointer" }}
                >
                  Visit the Ecolocation Rewards Portal
                </Link>
              </p>
            </div>
          </div>
          <UtilityCard
            id={3}
            title={"Explore the Metaverse with us"}
            desc={
              "At Gutter Bats Planet, we are committed to exploring all the possibilities of the metaverse. By joining the community, you will have access to every metaverse we enter. Plus, there will be additional perks within our metaverse private planets for Gutter Bats Planet NFT holders."
            }
          />
        </div>
        {width > 992 && <br />}
        <div class="row">
          <UtilityCard
            id={4}
            title={"Own the full commercial rights"}
            desc={
              "When you purchase a Gutter Bats Planet or Private planet NFT, the art is totally and completely yours. Whether you want to print and sell merchandise, use it in advertising, or want it to be the star of its own show!"
            }
          />
          <UtilityCard
            id={5}
            title={"Display your art in high resolution"}
            desc={
              "All Gutter Bats Planet are available as high resolution, 10,000px by 10,000px JPEGs. This allows you to print a high-quality physical copy of your NFT, display it in high res on a screen, and use it for large-scale print or display."
            }
          />
          <UtilityCard
            id={6}
            title={"Have a voice in the project"}
            desc={
              "Gutter Bats Planet gives you a voice in the development and success of the project through AMAs with the dev team and formalised voting systems."
            }
          />
        </div>
        {width > 992 && <br />}
        <div class="row">
          <UtilityCard
            id={7}
            title={"Decorate your Lazy Villa with NFT art"}
            desc={
              "We airdropped all Gutter Bats Planet holders a private planet - an NFT that could be used as a social media banner. The Villa App was then launched, allowing owners to link their other NFTs in the frames within their Lazy Villa."
            }
          />
          <UtilityCard
            id={8}
            title={"Expand your network"}
            desc={
              "Joining the Gutter Bats Planet community opens the door to a global network of like-minded people from all walks of life. Our community is filled with welcoming individuals who love to connect with newcomers. Plus, We even have dedicated networking channels for individuals who love to connect and welcome newcomers in our Discord!"
            }
          />
          <UtilityCard
            id={9}
            title={"Receive Airdrops"}
            desc={
              "As a Gutter Bats Planet NFT holder, you'll be eligible for future airdrops of tokens and other prizes."
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Utilities;
